import { NAVY, CORAL } from "./Brand";
// Pennant silhouette with SQUARE top corners (so the fill sits flush against the
// bottom of the nav bar) tapering to a rounded point. Drawn inside a 150 x 158 box.
const PENNANT_PATH = "M3,0 H147 V110 Q147,116 142,120 L83,149 Q75,153 67,149 L8,120 Q3,116 3,110 V0 Z";
// Same silhouette as an OPEN path that skips the top edge — the stroke runs down
// the sides and around the point only, letting the top read as part of the nav bar.
const PENNANT_STROKE_PATH = "M3,0 V110 Q3,116 8,120 L67,149 Q75,153 83,149 L142,120 Q147,116 147,110 V0";
export function PricingPennant({ label, price, unit, caption = "starting at", priceColor = CORAL, }) {
    return (<div className="relative" style={{ width: 150, height: 158, filter: "drop-shadow(0 14px 24px rgba(14,26,56,0.30))" }}>
      {/* Frosted glass fill */}
      <div className="absolute inset-0 bg-white/55 [backdrop-filter:blur(28px)_saturate(160%)]" style={{ clipPath: `path('${PENNANT_PATH}')` }} aria-hidden="true"/>

      {/* Bubble stroke outline — sides + point only, no top edge */}
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 150 158" fill="none" aria-hidden="true">
        <path d={PENNANT_STROKE_PATH} stroke="rgba(255,255,255,0.9)" strokeWidth={4} strokeLinecap="round"/>
      </svg>

      {/* Content */}
      <div className="relative flex h-full flex-col items-center px-5 pb-10 pt-5 text-center">
        <span className="shimmer-text text-[10px] font-semibold uppercase tracking-[0.12em]" style={{ color: NAVY }}>
          {label}
        </span>
        <span className="mt-2 h-1 w-8 shrink-0 rounded-full" style={{ backgroundColor: CORAL }} aria-hidden="true"/>
        <span className="mt-2 text-[10px] font-medium uppercase tracking-wide" style={{ color: `${NAVY}99` }}>
          {caption}
        </span>
        <span className="shimmer-text mt-2 text-2xl font-bold leading-none" style={{ color: priceColor }}>
          {price}
        </span>
        <span className="mt-1.5 text-[11px] font-medium" style={{ color: `${NAVY}CC` }}>
          {unit}
        </span>
      </div>
    </div>);
}
